import { message } from 'antd'

export default class Helper {
  static getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  static beforeUpload(file) {
    const allowedMimes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/gif'];
    const fileType = file.type
    if(!allowedMimes.includes(fileType)){
      message.error('File yang dapat di upload hanya berjenis PDF, JPEG, JPG, GIF!')
    }
    // const isFileType = file.type === 'image/jpeg' || file.type === 'image/png'
    // if (!isFileType) {
    //   message.error('You can only upload JPG/PNG file!')
    // }

    return false
  }

  static convertPrice(val) {
    if (val) {
      const convertInt = Math.ceil(parseFloat(val))
      const numberString = convertInt.toString()
      const sisa = numberString.length % 3
      let rupiah = numberString.substr(0, sisa)
      const ribuan = numberString.substr(sisa).match(/\d{3}/g)

      if (ribuan) {
        const separator = sisa ? '.' : ''
        rupiah += separator + ribuan.join('.')
      }
      return `Rp ${rupiah}`
    }
    return '0'
  }

  static numberOnly(val) {
    return /^\d*$/.test(val)
    // if (number.which !== 8 && isNaN(String.fromCharCode(number.which))) {
    //   number.preventDefault()
    //   debugger
    // }
  }

  static checkingFile(data) {
    // let widthImg, heightImg
    // const reader = new FileReader()
    // reader.readAsDataURL(data.file)
    // reader.addEventListener('load', event => {
    //   const _loadedImageUrl = event.target.result
    //   const image = document.createElement('img')
    //   image.src = _loadedImageUrl
    //   image.addEventListener('load', () => {
    //     widthImg = image.width
    //     heightImg = image.height
    //     // set image width and height to your state here
    //     console.log(widthImg, heightImg)
    //   });
    // })
    let isAllowedMimes = true;
    const allowedMimes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/gif'];
    const fileType = data.file.type
    if(!allowedMimes.includes(fileType)){
      isAllowedMimes = false;
    }
    // const isJpgOrPng = data.file.type === 'image/jpeg' || data.file.type === 'image/png'
    // if (!isJpgOrPng) {
    //   message.error('You can only upload JPG/PNG file!')
    // }
    const isLt2M = data.file.size / 1024 / 1024 < 1

    if (!isLt2M) {
      message.error('Image must smaller than 1MB!')
    }
    return isAllowedMimes && isLt2M
  }

  static changeKeyIdIngridients(data) {
    const newIngredients = data.map((item) => {
      if (item.id) {
        return ({
          ingridients_id: item.id, name: item.name, value: item.value, unit: item.unit,
        })
      }
      return ({ name: item.name, value: item.value, unit: item.unit })
    })
    return newIngredients
  }

  // static getPermissionId(data) {
  //   const newArr = data.map((item) => {
  //     if (item.id) {
  //       return (item.id)
  //     }
  //   })
  //   return newArr
  // }

  static getExtension(data) {
    return data.split('.').pop()
  }

  /**
   * Create copy of object with removed empty & falsy attribute  
   * 
   *  * **Falsy values include:** `false`, `0`, `""`, `null`, `undefined`, `NaN`.  
   *
   * @example
   * ```
   * const payload = { a: 1, b: null, c: false, d: "hello", e: undefined };
   * const cleanPayload = Helper.removeEmptyAttributes(payload);
   * console.log(cleanPayload); // { a: 1, d: "hello" }
   * ```
   * @param {Object} obj - The object to clean.
   * @returns {Object} A new object without falsy values.
   */
  static cleanObject(obj){
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => Boolean(v)));
  }

  /**
   * Create copy of object with removed attribute  
   *
   * @example
   * ```
   * const payload = { a: 1, b: 2, c: 3 };
   * const result = Helper.omitKeyObject(payload, 'c');
   * console.log(result); // { a: 1, b: 2 }
   * ```
   * @param {Object} obj - The object to process.
   * @param {...string} removedKeys - Removed attribute key
   * @returns {Object} A new object that already removed attribute
   */
  static omitKeyObject(obj, ...removedKeys){
    return Object.fromEntries(
      Object.entries(obj).filter(([key]) => !removedKeys.includes(key))
    );
  }

/**
  * Checks if a value is considered empty.
  *
  * Empty values:
  * - null
  * - undefined
  * - ""
  * - []
  * - {}
  *
  * @param {*} val - The value to check.
  * @returns {boolean} True if empty, false otherwise.
  */
  static checkIsEmpty(val){
    if (val === null || val === undefined) return true;
    if (typeof val === 'string') return val === '';
    if (Array.isArray(val)) return val.length === 0;
    if (typeof val === 'object') return Object.keys(val).length === 0;
    return false;
  }
}
